import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
@Injectable({
  providedIn: "root"
})
export class RestApi {
  // public readonly VEEVA_API_URL = environment.veevaauthUrl;
  
  public readonly API_URL = environment.authUrl;

  public readonly SWAGGER_URL = environment.swaggerUrl;

  public readonly API_URL_services = environment.baseUrl;

  public readonly API_URL_SPRING_BASE = environment.springBase;
  public readonly API_URL_FLASK_URL = environment.flaskurl;



  //public readonly API_URL_MIGRATION_TOOLS = environment.baseUrl;

  public readonly SWAGGERURL = this.SWAGGER_URL;

  public readonly GET_TABLE_DATA_URL = this.API_URL_services + "/commonRetrieveRecords";

  public readonly CREATE_RECORD_URL = this.API_URL_services + "/commonCreateRecord";

  public readonly UPDATE_RECORD_URL = this.API_URL_services + "/commonUpdateRecord";

  public readonly DELETE_RECORD_URL = this.API_URL_services + "/commonDeleteRecord";
  //delete record from db
  public readonly DELETE_RECORD_PERMANENT_URL = this.API_URL_services + "/deleteRecord";

  public readonly GET_TRNXTABLE_DATA_URL = this.API_URL_services + "/trnxRetrieveRecords";

  public readonly GET_TRNX_TABLE_DATA_FOR_DROPDOWNS = this.API_URL_services + "/trnxRetrieveRecordsForDropDowns";

  public readonly GET_CHILDTRNXTABLE_DATA_URL = this.API_URL_services + "/childtrnxRetrieveRecords";

  public readonly CREATE_TRNXRECORD_URL = this.API_URL_services + "/trnxCreateRecord";


  public readonly DELETE_TRNXMSTR_RECORD_URL = this.API_URL_services + "/deleteRecordFromMaster";

  public readonly CREATE_TRNXCHILDRECORD_URL = this.API_URL_services + "/trnxCreateChildRecord";

  public readonly UPDATE_TRNXRECORD_URL = this.API_URL_services + "/trnxUpdateRecord";

  public readonly DELETE_TRNXRECORD_URL = this.API_URL_services + "/trnxDeleteRecord";

  //LOGIN MODULE API
  //public readonly LOGIN_URL = this.API_URL + "veevasignin";
  public readonly VEEVALOGIN_URL = this.API_URL + "/veevasignin/Web";

  public readonly LOGIN_URL = this.API_URL + "/signin/Web";
  //public readonly LOGIN_VEEVA_URL = this.VEEVA_API_URL;

  public readonly forgot_URL = this.API_URL + "/forgotpassword";

  public readonly reset_Password_Mail = this.API_URL + "/resetpasswordmail";

  public readonly logOut_URL = this.API_URL_services + "/logout";

  public readonly loginReplace_URL = this.API_URL + "/replace/Web";

  public readonly veevaLoginReplace_URL = this.API_URL + "/replaceVeevaUser/Web";

  public readonly MICROSOFT_LOGIN_URL=this.API_URL+"/microsoftGenerateToken"

  public readonly RETRIEVE_TOWNSHIPMASTERFORLOGIN_URL = this.API_URL + "/retrieveTownshipMaster";

  public readonly RESETPWD_URL = this.API_URL_services + "/resetpassword";

  // Customer Support API
  public readonly CUSTOMERSUPPORT_URL = this.API_URL + "/insertSupportingMail";

  public readonly INSERT_SCREEN_CREATOR_URL = this.API_URL_SPRING_BASE + "/insertScreenCreator";

  public readonly RETRIEVE_SCREEN_CREATOR_URL = this.API_URL_SPRING_BASE + "/retrieveScreenCreator";

  public readonly UPDATE_SCREENCREATOR_URL = this.API_URL_SPRING_BASE + "/updateScreens";

  public readonly RETRIEVE_SCREEN_CREATOR_COMPLETE_DATA_URL = this.API_URL_SPRING_BASE + "/retrieveScreenCreatorCompleteData";

  public readonly RETRIEVE_SCREEN_BY_TABLE_NAME_URL = this.API_URL_SPRING_BASE + "/retrieveScreenByTableName";

  //Screens
  public readonly retrieveScreenNames = this.API_URL_SPRING_BASE + "/retrieveScreens";

  public readonly RETRIEVE_SCREENNAMES_FORDROPDOWN = this.API_URL_SPRING_BASE + "/retrieveScreensForDropDown";

  public readonly Retrieve_Transaction_Screen_Creator_Fields_URL = this.API_URL_SPRING_BASE + "/retrieveTransactionScreenCreatorFields";

  public readonly RETRIEVE_TRNXSCREEN_BY_TABLE_NAME_URL = this.API_URL_SPRING_BASE + "/retrieveTrnxScreenByTableName";

  public readonly RETRIEVE_TRNXCHILDSCREEN_BY_TABLE_ID_URL = this.API_URL_SPRING_BASE + "/retrieveTrnxScreenByParentScreenId";

  public readonly Insert_Transaction_Screen_Creator_URL = this.API_URL_SPRING_BASE + "/insertTrnxScreenCreator";

  public readonly RETRIEVE_SCREEN_CREATOR_TRANSACTION_MASTER_URL = this.API_URL_SPRING_BASE + "/retrieveTrnxMasterScreenCreator";

  public readonly RETRIEVE_SCREEN_CREATOR_TRANSACTION_CHILD_URL = this.API_URL_SPRING_BASE + "/retrieveTrnxChildScreenCreator";

  public readonly GET_TABLE_SINGLE_RECORD_URL = this.API_URL_services + "/commonRetrieveSingleRecord";

  
  public readonly GET_TEST_SCRIPTS_FOR_SELECTED_DNS = this.API_URL_SPRING_BASE + "/commonRetrieveRecordByDnsId";

  //Name - Amol Nehere
  public readonly RETRIEVE_CONCRETE_UPDATE_RECORD = this.API_URL_SPRING_BASE + "/retrieveRequisitionForWeb"

  public readonly RETRIEVEDROPDOWN_URL = this.API_URL_services + "/getlistnostatuscheck";

  public readonly RETRIEVENAMEDROPDOWN_URL = this.API_URL_SPRING_BASE+"/retrieveObjectAttributeNames"

  public readonly RETRIEVE_TABLEDATA_URL = this.API_URL_services + "/retrievetabledata";

  public readonly UPDATECONCRETE_URL = this.API_URL_SPRING_BASE + "/updateRequisition";

  public readonly DELETE_TABLE_URL = this.API_URL_services + "/deleteTableAndScreen";

  public readonly RETRIEVEDISPATCHHISTORYDATA_URL = this.API_URL_SPRING_BASE + '/retrieveRequisitionDispatchHistory';

  public readonly RETRIEVERETURNEDORDERS_URL = this.API_URL_SPRING_BASE + '/retrieveReturnedOrdersForWeb';

  public readonly UPDATERETURNEDORDERS_URL = this.API_URL_SPRING_BASE + '/updateReturnedOrdersForWeb';

  public readonly UPADTE_USER_RECORD_URL = this.API_URL_SPRING_BASE + "/updateUserRecord";

  public readonly RETRIEVEBATCHPLANTDATA_URL = this.API_URL_SPRING_BASE + '/retrieveBatchPlantScheduling';

  public readonly INSERTBATCHPLANTDATA_URL = this.API_URL_SPRING_BASE + '/insertBatchPlantScheduling';

  public readonly UPDATEBATCHPLANTDATA_URL = this.API_URL_SPRING_BASE + '/updateBatchPlantScheduling';

  public readonly DELETEBATCHPLANTDATA_URL = this.API_URL_SPRING_BASE + '/deleteBatchPlantScheduling';

  /**@author Umashankar, @date 25-2-2021, @description url is used to retrieve batch plant data for schedule calendar */

  public readonly RETRIEVEBATCHPLANTDATAFORSCHEDULECALENDAR_URL = this.API_URL_SPRING_BASE + '/retrieveBatchPlantSchedulingCalendar';

  /**@author Umashankar, @date 01-03-2021, @description url is used to retrieve batch plant list for schedule master */

  public readonly RETRIEVEBATCHPLANTLISTFORSCHEDULECALENDAR_URL = this.API_URL_services + '/trnxRetrieveRecords';

  public readonly RETRIEVE_OBJECTS_URL = this.API_URL_SPRING_BASE + '/retrieveReporting';

  public readonly RETRIEVE_TABLES_FIELDS_URL = this.API_URL_SPRING_BASE + '/retrieveReportingTableFields';

  //Inset Reports API
  public readonly INSERT_REPORT = this.API_URL_SPRING_BASE + "/insertReports";

  public readonly INSERT_MIGRATION_JSONS_URL = this.API_URL_SPRING_BASE + "/insertMigrationJsons";

  public readonly RETRIEVE_QUICKSIGHT = this.API_URL_SPRING_BASE + "/getQuickSight";

  public readonly RETRIEVE_ANALYSIS = this.API_URL_SPRING_BASE + "/getAnalysisById";

  public readonly RETRIEVE_ANALYSISBYID = this.API_URL_SPRING_BASE +"/getAnalysis";

  public readonly INSERT_REPORTINSTANCEFROMQUICKSIGHT = this.API_URL_SPRING_BASE +"/InsertReportInstanceFromQuickSight";

  /**@author Umashankar, @date 21-4-2021, @description Url is used to extract the data */
  public readonly GETEXTRACTDATA_URL = this.API_URL_SPRING_BASE + "/extractDocuments";

  /**@author Umashankar, @date 21-4-2021, @description Url is used to extract the data */
  public readonly CONVERTTOJSONDATA_URL = this.API_URL_SPRING_BASE + "/buildJson";

  /**@author Umashankar, @date 21-4-2021, @description Url is used to extract the data */
  public readonly LOADTOS3DATA_URL = this.API_URL_SPRING_BASE + "/uploadJson";

  public readonly RETRIEVE_MASTER_DATA_LOAD_LOG = this.API_URL_SPRING_BASE + "/retrieveMasterDataLoadLog";

  public readonly INSERT_EXTRACT_BUILD_UPLOAD = this.API_URL_SPRING_BASE + "/extractBuildUpload";

  //elastic search api
  public readonly GET_ELASTIC_SEARCH_DATA = this.API_URL_SPRING_BASE + "/returnElastic";

  public readonly GET_ELASTIC_SEARCH_FILTER_DATA = this.API_URL_SPRING_BASE + "/returnElasticfilter";

  public readonly RETRIEVE_REPORTLINKS_URL = this.API_URL_SPRING_BASE + "/retrieveReportCreation";

  public readonly RETRIEVE_REPORT_URL = this.API_URL_SPRING_BASE + "/retrieveReportCreationBasedOnOwnerName";

  public readonly INSERT_REPORTLINKS_URL = this.API_URL_SPRING_BASE + "/insertReportCreation";
  
  public readonly FetchUserRole_URL = this.API_URL_SPRING_BASE +"/fetchUserRole/";

  public readonly FetchUserRoleAndName_URL = this.API_URL_SPRING_BASE +"/fetchUserRoleAndRoleName/";
  //Filters manage
  public readonly INSERT_FILTERS = this.API_URL_SPRING_BASE + "/insertFilterManage";
  public readonly UPDATE_FILTERS_LIST = this.API_URL_SPRING_BASE + "/updateFilterManage";
  public readonly RETRIEVE_FILTERS = this.API_URL_SPRING_BASE + "/retrieveFilterManage";
  public readonly UPDATE_FILTER = this.API_URL_SPRING_BASE +"/updateFilterRecord";
  // schedule and filters api
  public readonly RETRIEVE_SCHEDULE_URL = this.API_URL_services + "/retrievetabledata";
  public readonly RETRIEVE_FILTERS_URL = this.API_URL_services + "/commonRetrieveSingleRecord/retrieveinstanceschedules_view/templatecreationmstrid/1";
  public readonly INSERT_REPORTPOPUP_URL = this.API_URL_SPRING_BASE + "/insertReportInstance";
  public readonly UPDATE_SENTVAULT_URL = this.API_URL_SPRING_BASE + "/UpdateReportInstanceDetailsById"

  //Objectgroup api
  public readonly INSERT_OBJECTGROUP = this.API_URL_SPRING_BASE + "/createObjectGroup";
  public readonly RETRIEVE_OBJECTGROUP = this.API_URL_SPRING_BASE +"/retrieveObjectGroup";
  public readonly RETRIEVE_VAULTOBJECTS = this.API_URL_SPRING_BASE +"/retrieveObjectGroupByGroupName";
  public readonly DELETE_OBJECTGROUP = this.API_URL_SPRING_BASE +"/deleteMstrObjectGroup";
  public readonly UPDATE_OBJECTGROUP = this.API_URL_SPRING_BASE +"/updateObjectGroup";

  //Javers audit
  public readonly RETRIEVE_JAVERS_URL = this.API_URL_SPRING_BASE + "/javersauditretrieve";

  public readonly CHECKTABLE_EXISTS = this.API_URL_SPRING_BASE +"/CheckTableExistOrNot";
  //Audit Trail
  public readonly RETRIEVE_AUDIT_URL = this.API_URL_SPRING_BASE + "/reteriveAuditRecords";
  public readonly RETRIEVE_AUDIT_URL_IN_Range = this.API_URL_SPRING_BASE + "/reteriveAuditInRange";

  //objectAttributes
  public readonly RETRIEVE_OBJECTATTRIBUTES = this.API_URL_SPRING_BASE +"/retrieveObjectAttributesLog";
  public readonly INSERT_OBJECTATTRIBUTES = this.API_URL_SPRING_BASE +"/insertobjectattributes";

  public readonly DATABASE_NAMES = this.API_URL_services +"/commonRetrieveSingleRecord/vaultconfigmstr/vaultconfigmstrid";

  public readonly RETRIEVE_DATA_BY_NAME= this.API_URL_SPRING_BASE +"/retrieveobjectattributes";


  //migration tools
  public readonly RETRIEVE_TOOLS = this.API_URL_services  +"/getToolInfo";
  public readonly RETRIEVE_TOOL_LOG = this.API_URL_services  +"/toolServiceLogInformation/";
  public readonly XML_TO_CSV_SQL = this.API_URL_services  +"/xmlToCsvToSql";
  public readonly XML_MODIFIER = this.API_URL_services  +"/xmlModifier";
  public readonly XML_SPLITTER = this.API_URL_services  +"/xmlSplitter";
  public readonly CSV_SQL = this.API_URL_services  +"/csvToSql";
  public readonly ZIP_FILE_EXTRACT =this.API_URL_SPRING_BASE + "/zipfileextraction"
  public readonly Update_Case_State = this.API_URL_SPRING_BASE + "/updateLifeCycleState";
  public readonly UPDATE_PRODUCT_TYPE_CHANGE = this.API_URL_SPRING_BASE + "/updateProductType";
  public readonly RETRIEVE_CASE_STATE_USERACTIONS = this.API_URL_SPRING_BASE+"/retrieveLifeCycleStateAction";
  public readonly RETRIEVE_UPDATE_CASE_STATE =this.API_URL_SPRING_BASE + "/retrieveLifeCycleState"

 //retrive Vault DNs Access
 public readonly VAULT_DNS_ACCESS_DATA=this.API_URL_SPRING_BASE +"/retrieveVaultDNSAccess";
 public readonly VAULT_DNS_INSERT_DATA=this.API_URL_SPRING_BASE +"/insertVaultDNSAccess";


  //DNS Url
  public readonly RETRIEVE_USERDNS_URL = this.API_URL + "/retrieveuserdns";
  public readonly RETRIEVE_USERSELECTEDDNS_URL = this.API_URL +"/retrieveuserselecteddns";

  //Multiple object extraction
  public readonly INSERT_MULTIPLEOBJECTATTRIBUTES = this.API_URL_SPRING_BASE +"/objectsExtractor";


  //ETL
  public readonly TRANSFORMATION = this.API_URL_SPRING_BASE+"/transformSourceFiles"; // for transformation

  public readonly LOADING = this.API_URL_SPRING_BASE+"/vaultLoader";// for loading

  public readonly RESUMELOADING = this.API_URL_SPRING_BASE+"/vaultReloader";

  public readonly RESUMELOADFORPARALLEL = this.API_URL_SPRING_BASE+"/startReload";

  public readonly RETRIEVEDATA = this.API_URL_SPRING_BASE+"/retrieveVaultLoadInstructions";// to retrieve data and bind to ag grid

  public readonly STARTMIGRATION = this.API_URL_SPRING_BASE+"/insertMigrationParent";// to start migration process

  public readonly ABORTMIGRATION = this.API_URL_SPRING_BASE+"/updateMigrationParent";// to abort migration process

  public readonly GET_MIGRATIONTRACE_DATA = this.API_URL_SPRING_BASE+"/retrieveMigrationTrace";

  public readonly UPLOADMAPPINGFILE = this.API_URL_SPRING_BASE+"/uploadMappingFile";

  public readonly RETRIEVEMAPPINGFILE = this.API_URL_SPRING_BASE+"/retrieveMappingFile";

  public readonly DOWNLOADMAPPINGFILE = this.API_URL_SPRING_BASE+"/downloadMappingFile";

  public readonly downloadFileUrl=this.API_URL_SPRING_BASE+"/downloadFile"
  public readonly zipanddownloadfilesUrl=this.API_URL_SPRING_BASE+"/zipanddownloadfiles"
  public readonly DOWNLOADSOURCEFILE=this.API_URL_SPRING_BASE+"/downloadSourcefile"
  public readonly zipanddownloadanyfilesFromS3=this.API_URL_SPRING_BASE+"/zipanddownloadanyfilesFromS3"
  public readonly zipanddownloadanyfilesFromS3UsingPathOnly = this.API_URL_SPRING_BASE+"/zipanddownloadanyfilesFromS3UsingPathOnly"

    public readonly UPLOAD_EXTERNALFILE_S3 = this.API_URL_SPRING_BASE+"/uploadFileTospecificPath"
    public readonly DOWNLOAD_LIBRARY_OBJECT = this.API_URL_SPRING_BASE+"/downloadLibraryObject"


  public readonly DOWNLOADREPORTVALIDATIONFILE = this.API_URL_SPRING_BASE+"/downloadValidationReportFile";

  public readonly DOWNLOADREPORTSUMMARYFILE = this.API_URL_SPRING_BASE+"/downloadSummaryReportFile";

  public readonly DOWNLOADEXTRACTFILE = this.API_URL_SPRING_BASE+"/downloadExtractionFile";

  public readonly DOWNLODSOURCEFILE = this.API_URL_SPRING_BASE+"/downloadSourceFile"

  public readonly UPLOADSOURCEFILE = this.API_URL_SPRING_BASE+"/uploadSourceFile";

  public readonly UPLOADCSVFILE = this.API_URL_SPRING_BASE+"/uploadCsvFile";

  public readonly UPLOADSOURCEFILEPARALLEL = this.API_URL_SPRING_BASE+"/uploadSourceFileForload";

  // New ETL Screen api's

  public readonly REEXTRACTLIBRARYOBJECT = this.API_URL_SPRING_BASE+"/extractVaultObjectForTransformation";

  public readonly RETRIEVEVAULTOBJECTS = this.API_URL_SPRING_BASE+"/retrieveVaultLibraryObject";

  public readonly GET_TABLE_SINGLE_RECORD_FORETL = this.API_URL_SPRING_BASE + "/retrieveMigration";

  public readonly RUNMIGRATIONE2B = this.API_URL_SPRING_BASE + "/runE2BMigration";

  public readonly INSERTETOBTASK = this.API_URL_SPRING_BASE + "/insertetobtype";

  public readonly INSERTMAPPINGFILEETOB = this.API_URL_SPRING_BASE + "/insertetobfiel";

  public readonly RETRIEVEETOOBJECTS = this.API_URL_SPRING_BASE + "/retrieveE2BObjects";

  public readonly GENERATESUMMARYREPORT = this.API_URL_SPRING_BASE + "/generatevalsummaryreport";

  public readonly INSERTJSUITEMIGRATIONPARENT = this.API_URL_SPRING_BASE + "/insertjsuitemigrationparent";

  // api call to retrieve deffered objects. Written by kalpesh
  public readonly DEFFEREDOBJECTS = this.API_URL_services +"/commonRetrieveSingleRecord/loadobjectsmstr/tenantid";

  // Permission names
  public readonly retrievePermissionNames = this.API_URL_SPRING_BASE + "/retrieveScreensWeb";

  public readonly retrievebysubchildPermissionNames = this.API_URL_SPRING_BASE + "/screenoperationspermissionBasedOnroleId";

  // Permission Access
  public readonly updatePermissionAccess = this.API_URL_SPRING_BASE + "/insertAccessPermission";
  
  //ButtonPermissions to update DB
  public readonly insertIntoScreenOperationPermission = this.API_URL_SPRING_BASE + "/insertIntoScreenOperationPermission";

  // Assign User Role
  //retrieve Users For Assign User Role
  public readonly RETRIEVE_USERS_ASSIGN_USER_ROLE = this.API_URL_SPRING_BASE +"/retrieveUsersForAssignUserRole"

  //insert Assign User Role
  public readonly INSERT_ASSIGN_USER_ROLE = this.API_URL_SPRING_BASE +"/insertAssignUserRole"

  //retrieve Assign Users Role By DnsId
  public readonly RETRIEVE_ASSIGN_USER_ROLE_BYDNS_ID = this.API_URL_SPRING_BASE +"/retrieveAssignUsersRoleByDnsId"

  //is User Role available For User
  public readonly IS_USER_ROLE_AVAILABLE_FOR_USER = this.API_URL_SPRING_BASE + "/isUserRoleavailableForUser"

  //reterive user Role By Tenant Id And UserId
  public readonly RETERIVE_USER_ROLE_BY_TENANTID_AND_USERID = this.API_URL_SPRING_BASE + "/reteriveuserRoleByTenantIdAndUserId"

  public readonly RETRIEVEJSUITEPROPERTIES = this.API_URL_SPRING_BASE + "/retrievePropertyValueForLoad";

  // ETL update case data api's
  public readonly UPLOADOBJECTFILE = this.API_URL_SPRING_BASE + "/uploadSourceFileForUpateLoad";
  public readonly UPDATECASEDATA = this.API_URL_SPRING_BASE + "/initiateUpdateCaseLoad";
  public readonly DELETECASEDATA = this.API_URL_SPRING_BASE + "/deleteuploadedSourceFileForUpdateLoad";

  // JMigrator tool R3 Extractor api's

  public readonly UPLOADR3EXTRACTOR = this.API_URL_SPRING_BASE + "/ExtractDocumentsFromVault";

  public readonly RETRIEVER3EXTRACTOR = this.API_URL_SPRING_BASE + "/retrieveScheduledJobsByDnsId";


  public readonly INSERT_CSV_FILE_TO_S3 = this.API_URL_SPRING_BASE + "/insertcsvfiletoS3"

  public readonly GENERATESPLITREPORT = this.API_URL_SPRING_BASE + "/generatesplitreport";

  // UserRoleMstr Api's

  public readonly RETERIVE_USER_ROLEMSTR_BY_DNS_ID = this.API_URL_SPRING_BASE + "/reteriveUserRoleMstrByDnsId"

  //reterive multi and single object attribute by dnsid and source
  public readonly RETRIEVEOBJECTLABELBYDNSIDANDSOURCE = this.API_URL_SPRING_BASE +"/retrieveobjectLabelByDnsidAndSource"

  public readonly RETRIEVINGATTACHMENTLOADDETAILS = this.API_URL_SPRING_BASE+"/retrievingAttachmentLoadDetails"

  public readonly UPDATELOADREADYSTATUS = this.API_URL_SPRING_BASE  + "/attachmentLoad/updateLoadStatus"

  public readonly ATTACHMENTLINKTOCASE = this.API_URL_SPRING_BASE+ "/attachmentLinkToCase"

  public readonly RESUMEVAULTOBJECTEXTRACTION = this.API_URL_SPRING_BASE+ "/resumeVaultObjectExtraction"


  public readonly INSERTMIGRATIONTRACERECORDS = this.API_URL_SPRING_BASE+ "/insertMigrationTraceRecords"

  public readonly REINITIATEMIGRATION = this.API_URL_SPRING_BASE+ "/reInitiateMigration"

  public readonly REMIGRATE = this.API_URL_SPRING_BASE+ "/reMigrate"


  public readonly VALIDATEMAPPINGFILE = this.API_URL_SPRING_BASE+ "/ValidateMappingFile"

  public readonly DOWNLOADFILEFROMS3 = this.API_URL_SPRING_BASE+ "/downloadFile"
   public readonly DOWNLOADCSVFILEFROMS3 = this.API_URL_SPRING_BASE+ "/downloadCsvFileFromS3"

  public readonly RETRIEVEOBJECTFIELDSURLBYDNSID = this.API_URL_SPRING_BASE+"/retrieveObjectFieldsUrlByDnsId"
  
  public readonly DOWNLOADFILESANDZIP = this.API_URL_SPRING_BASE+ "/downloadFilesAndZip"

  public readonly DELETECASEFROMVAULT = this.API_URL_SPRING_BASE+ "/updateCaseForDeletion"

  public readonly GETGLOBALOBJECTSLISTBYDNSID = this.API_URL_SPRING_BASE+ "/GetGlobalObjectsListByDnsId"

  public readonly CREATEGLOBALOBJECTS = this.API_URL_SPRING_BASE+ "/createGlobalObjects"


  // Extraction Schedule
  public readonly INSERT_EXTRACTION_SCHEDULE_URL = this.API_URL_SPRING_BASE + "/insertExtractionSchedule";

  public readonly EXTRACTION_SCHEDULE_LIST = this.API_URL_SPRING_BASE + "/extractionScheduleList";
  public readonly EXTRACTIONSCHEDULELISTBYSCHEDULEFORANDREPORTTEMPLATE = this.API_URL_SPRING_BASE + "/extractionScheduleListByScheduleForAndReportTemplate"

  public readonly DELETE_EXTRACTION_SCHEDULE_URL =  this.API_URL_SPRING_BASE +"/deleteExtractionSchedule"

  public readonly RETERIVEINCREMENTALEXTRACTIONHISTORY =  this.API_URL_SPRING_BASE +"/reteriveIncrementalExtractionHistory"

  public readonly RETRIEVE_COMMON_REPORT_URL = this.API_URL_services + "/retrieveCommonReports";

  public readonly GETLISTBYMULTIPLEWHERECLAUSE =  this.API_URL_services + "/getlistByMultiplewhereclause";

  public readonly RUNCUSTOMREPORTGENERATIONMANUALLY= this.API_URL_SPRING_BASE + "/runCustomReportGenerationManually"

  public readonly INSERTUPDATETESTEXECUTION= this.API_URL_SPRING_BASE + "/insertUpdateTestExecution"

  public readonly RETRIEVETESTEXECUTIONS= this.API_URL_SPRING_BASE + "/retrieveTestExecutions"

  public readonly DELETETESTEXECUTION= this.API_URL_SPRING_BASE + "/deleteTestExecution"

  public readonly RETRIEVETESTEXECUTIONBYCYCLEMSTRID = this.API_URL_SPRING_BASE + "/retrieveTestExecutionByCycleMstrId"

  public readonly GETLOOKUPVAULEBYLOOKUPTYPE = this.API_URL_SPRING_BASE+ "/getlookupVauleByLookUpType"

  public readonly RETRIEVEVAULTBINDERTEMPLATESCOLLECTION = this.API_URL_SPRING_BASE+ "/retrieveVaultBinderTemplatesCollection"

  public readonly INSERTUPDATEREPORTTEMPLATE = this.API_URL_SPRING_BASE+ "/insertUpdateReportTemplate"

  public readonly RETRIEVEVAULTBINDERTEMPLATESECTIONS = this.API_URL_SPRING_BASE+ "/retrieveVaultBinderTemplateSections"

  public readonly RETRIEVEREPORTTEMPLATESBYDNSID = this.API_URL_SPRING_BASE+ "/retrieveReportTemplatesByDnsId"

  public readonly DELETEREPORTTEMPLATEBYID = this.API_URL_SPRING_BASE+ "/deleteReportTemplateById"

  public readonly RETERIVEFULLDATALOADLOG =  this.API_URL_SPRING_BASE +"/retrieveMasterDataLog"

  public readonly INSERTONLYREPORTINSTANCE = this.API_URL_SPRING_BASE+ "/insertOnlyReportInstance"

  public readonly GETPARENTREPORTTEMPLATEDETAILS =  this.API_URL_SPRING_BASE + "/getParentReportTemaplateDetails";

  public readonly REEXECUTEGENERATEREPORTPUSHTOVAULT = this.API_URL_SPRING_BASE + "/reExecuteGenerateReportPushToVault";

  public readonly RETRIEVEGENERATEDREPORTLIST =  this.API_URL_SPRING_BASE + "/retrieveGeneratedReportList"

  public readonly RETRIEVEALLVAULTDOCUMENTTYPES = this.API_URL_SPRING_BASE + "/retrieveAllVaultDocumentTypes";

  public readonly RETRIEVEVAULTDOCUMENTSUBTYPES = this.API_URL_SPRING_BASE + "/retrieveVaultDocumentSubTypes";

  public readonly RETRIEVEVAULTDOCUMENTLIFECYCLEFORCLASSIFICATIONS = this.API_URL_SPRING_BASE + "/retrieveVaultDocumentLifecycleForClassifications";

  public readonly RETRIEVEVAULTDOCUMENTCLASSIFICATIONS = this.API_URL_SPRING_BASE + "/retrieveVaultDocumentClassifications";

  public readonly SCHEDULENEXTREPORT = `${this.API_URL_SPRING_BASE}/scheduleNextReport`;

  public readonly RETRIEVE_MULTISELECT_VALUE = this.API_URL_SPRING_BASE + "/getAttributesAndValues";

  public readonly RETRIEVE_DOWNLOAD_DATASET_METADATA = this.API_URL_SPRING_BASE + "/downloadDatasetMetadata";

  public readonly RETRIEVE_ALL_OBJECTS_URL = this.API_URL_SPRING_BASE + '/retrieveAllReportingObjects';

  public readonly CREATE_FACETS_URL = this.API_URL_SPRING_BASE + '/createFacets';

  public readonly RETRIEVE_ALL_FACETS_URL = this.API_URL_SPRING_BASE + '/retrieveFacets';

  public readonly RETRIEVE_DATASET_URL = this.API_URL_SPRING_BASE + "/retrieveReportCreation";

  public readonly RETRIEVE_DATASET_URL_BINDER = this.API_URL_SPRING_BASE + "/retrieveDatasetByBinder";

  public readonly UPDATEDATASET_QUICK_SIGHT_URL=this.API_URL_SPRING_BASE +"/getDatasetapi";


  public readonly GENERATE_ANALYSIS_URL = this.API_URL_SPRING_BASE + "/generateAnalysis";

  public readonly ADHOC_REPORT = this.API_URL_SPRING_BASE+ "/generateReportPushToVault";

  public readonly REPORT_INSTANCE = this.API_URL_SPRING_BASE+ "/reportIntance"

  public readonly RETRIEVE_DATASET = this.API_URL_SPRING_BASE+"/retrieveDataset";

  public readonly CHECK_DATASET_IS_EDITABLE = this.API_URL_SPRING_BASE + '/checkDatasetIsEditable';
  
  public readonly DELETE_DATASET = this.API_URL_SPRING_BASE + '/deleteReportCreation';

  public readonly RETRIEVE_VAULT_SESSIONID = this.API_URL_SPRING_BASE+'/session'


  public readonly INSERT_DATASET_GROUP = this.API_URL_SPRING_BASE+'/createdatasetgroup';

  public readonly RETRIEVE_DATASET_GROUP = this.API_URL_SPRING_BASE+ '/retrieveDatasetGroup'

  public readonly RETRIEVE_DATASET_BY_DATASETGROUPID = this.API_URL_SPRING_BASE+ "/retrieveDatasetGroupById"

  public readonly DETELE_DATASET_GROUP = this.API_URL_SPRING_BASE+"/deleteDatasetGroup"

  public readonly UPDATE_DATASET_GROUP = this.API_URL_SPRING_BASE+"/updateDatasetGroup";

  public readonly RETRIEVE_DATASET_OBJECTS = this.API_URL_SPRING_BASE+"/retrieveDatasetObjects";

  public readonly GET_GLOBAL_OBJECTS=this.API_URL_SPRING_BASE+"/retrieveMigrationGlobalObjectsByExtractionType";

  public readonly RETRIEVE_REFRESH_HISTORY = this.API_URL_SPRING_BASE + "/refreshHistory";

  public readonly RETRIEVE_IMPORT_EXPORT_HISTORY = this.API_URL_SPRING_BASE + "/importExportHistory";

  public readonly RETRIEVE_REFRESH_STATUS = this.API_URL_SPRING_BASE+"/objectsRefreshStatus";

  public readonly RETRIEVE_VAULTCONFIG_DETAILS = this.API_URL_SPRING_BASE+ "/retrieveVaultConfigMstrDetails";

  public readonly UPDATE_AUTORENEW_SESSION = this.API_URL_SPRING_BASE + "/updateAutoRenewSession"

  public readonly STOP_SESSION_AUTORENEW = this.API_URL_SPRING_BASE+ "/deleteSessionUpdateSchedular"

  public readonly START_SESSION_AUTORENEW_SCHEDULAR = this.API_URL_SPRING_BASE+"/startAutoSessionRenewSchedular"

  public readonly RETRIEVEEXTRACTIONTRANSFORMATIONINSTRUCTION=this.API_URL_SPRING_BASE+"/retrievePrepareExtractionTransformationInstruction/"

  public readonly RETRIEVE_ALL_OBJECTGROUPNAME= this.API_URL_SPRING_BASE+"/retrieveAllObjectGroup"

  public readonly INSERT_MSTR_OBJECT_GROUP = this.API_URL_SPRING_BASE+'/createMstrObjectGroup';

  public readonly RETRIEVE_ALL_OBJECTGROUP = this.API_URL_SPRING_BASE +"/retrieveAllMstrObjectGroup";

  public readonly RETRIEVE_VAULTOBJECTS_GROUP = this.API_URL_SPRING_BASE +"/retrieveObjectGroupDetails";

  public readonly RETRIEVE_GROUP_OBJECTS = this.API_URL_SPRING_BASE + '/retrieveGroupObjects';

  public readonly RETRIEVE_JSUITE_PROPERTY=  this.API_URL_SPRING_BASE  +"/retrieveProperties";


  public readonly RETRIEVEINSTRUCTIONSBASEDONACTIVITY=this.API_URL_SPRING_BASE+"/retrievePreparedInstructions/"

  public readonly RETRIEVE_SCRAPING_WEB_PAGES=this.API_URL_SPRING_BASE+"/retrieveScrapingWebPages"
  public readonly INSERT_SCRAPING_WEB_PAGES=this.API_URL_SPRING_BASE+"/insertIntoScrapingWebPages"

  public readonly RETRIEVE_SCRAPING_HISTORY=this.API_URL_SPRING_BASE+"/retrieveScrapingHistory"
  public readonly RETRIEVE_COMPARE_HISTORY=this.API_URL_SPRING_BASE+"/retrieveCompareHistory"
  public readonly INSERT_SCRAPING_HISTORY=this.API_URL_SPRING_BASE+"/insertIntoScrapingHistory"
  public readonly INSERT_COMPARE_HISTORY=this.API_URL_SPRING_BASE+"/insertIntoCompareHistory"
  public readonly SCRAPE_WEB_PAGE=this.API_URL_SPRING_BASE+"/scrapeTheWebpage"
  public readonly Compare_History_PAGE=this.API_URL_SPRING_BASE+"/generateCompareReport"
  public readonly RETRIEVE_SYSTEMNAME = this.API_URL_SPRING_BASE+"/retrieveSystemName"
  public readonly DOWNLOAD_COMPARE_REPORT_DIRECTORY = this.API_URL_SPRING_BASE+"/downloadCompareReportDirectory"



  public readonly RETRIEVE_SOURCE_AND_TARGET = this.API_URL_SPRING_BASE+"/retrieveSourceAndTarget"
  
  public readonly GET_OBJECTGROUP_NAMES = this.API_URL_SPRING_BASE+"/getObjectGroups"
  public readonly GET_SELECTED_OBJECTGROUP_NAMES=this.API_URL_SPRING_BASE+"/getSelectedObjectGroupsNames";
//Access Management url
  public readonly RETRIVE_DNS=this.API_URL_SPRING_BASE+"/retriveDns"
  public readonly RETRIVE_SECRET_AND_REGION_BASEDON_DNSID=this.API_URL_SPRING_BASE+"/retrieveSecretDetails"
  public readonly RETRIVE_DNS_USERS=this.API_URL_SPRING_BASE+"/retriveUsers"
  public readonly SAVE_DNS_USER=this.API_URL_SPRING_BASE+"/dnsuser"
  public readonly RETRIVE_DNS_USER_RECORD=this.API_URL_SPRING_BASE+"/retriveAcess"
  public readonly RETRIVE_LOG_IN_USER=this.API_URL_SPRING_BASE+"/retriveloginuser"
  public readonly DELETE_RECORD=this.API_URL_SPRING_BASE+"/deleteAccessRecord"
  public readonly INSERT_ONESIGNAL_USER=this.API_URL_SPRING_BASE+"/insertUserPlayerId"
  
  // public readonly SCRAPE_WEB_PAGE=this.API_URL_SPRING_BASE+"/scrapeTheWebpage"
  // public readonly Compare_History_PAGE=this.API_URL_SPRING_BASE+"/generateCompareReport"
  
  public readonly REINITIATEMIGRATIONFORINCREMENTALLOAD=this.API_URL_SPRING_BASE+"/reIntiateMigrationForIncrementalLoad";

  public readonly RETRIEVE_About_record=this.API_URL_services+"/retriveabout"
  public readonly RETRIEVE_LOOKUPVALUE = this.API_URL_SPRING_BASE+"/retrieveLookupvalue";
  public readonly RETRIEVE_VAULT_VERSIONS = this.API_URL_SPRING_BASE+"/vaultVersion";
  public readonly UPDATE_VAULT_VERSION = this.API_URL_SPRING_BASE+"/updateVaultVersion";
  public readonly RETRIEVE_SCRIPTS_VERSION = this.API_URL_SPRING_BASE+"/retrieveScriptVersions";


  // vault Object Relationship Apis
  public readonly RETRIEVE_VAULT_OBJECT_RELATIONSHIP=this.API_URL_SPRING_BASE+"/getCompleteVaultObjectRelationshipList"
  public readonly INSERT_VAULT_OBJECT_RELATIONSHIP=this.API_URL_SPRING_BASE+"/insertIntoVaultObjectRelationship"
  public readonly UPDATE_VAULT_OBJECT_RELATIONSHIP=this.API_URL_SPRING_BASE+"/updateVaultObjectRealtionship"
  public readonly DELETE_VAULT_OBJECT_RELATIONSHIP=this.API_URL_SPRING_BASE+"/deleteVaultObjectRealtionship"
  public readonly DOWNLOAD_VAULT_OBJECT_RELATIONSHIP=this.API_URL_SPRING_BASE+"/downloadVaultObjectRelationshipListUrl"

  public readonly SAVE_RUNNING_SERVICE = this.API_URL_SPRING_BASE+"/saveRunningservice"
  public readonly RETRIVE_RUNNING_SERVICE = this.API_URL_SPRING_BASE+"/retriveRunningservice"
  public readonly RETRIVE_AVAILABLE_SERVICE = this.API_URL_SPRING_BASE+"/availableService"

  public readonly SAVE_AVAILABLE_SERVICE = this.API_URL_SPRING_BASE+"/saveAvailableservice"
  public readonly RETRIVE_REMAIN_SERVICE = this.API_URL_SPRING_BASE+"/retriveRemainningservice"

  public readonly RETRIEVE_PREVALIDATE_CONFIGURATIONS=this.API_URL_SPRING_BASE+"/retrievePropertiesBasedOnDnsIdAndMigrationId/"
  public readonly VALIDATE_CONFIGURATIONS=this.API_URL_SPRING_BASE+"/validateProperties/"
  public readonly RETRIEVE_PREVALIDATE_CONFIGURATION_BY_PROPERTYTYPE=this.API_URL_SPRING_BASE+"/retrievePreValidateConfiguartionsBasedOnPropertyType/"
  public readonly SAVE_PREVALIDATE_INSTRUCTION=this.API_URL_SPRING_BASE+"/savePreValidationConfiguration/"

  public readonly RETRIVE_SECRET = this.API_URL_SPRING_BASE+"/retriveSecrets"

  public readonly CREATE_SECRET = this.API_URL_SPRING_BASE+"/createSecrets"
  public readonly SAMPLETEST = this.API_URL+"/sampleTest"
  public readonly DECRYPT_USERNAME = this.API_URL+"/decryptUsername"
  public readonly searchCase = this.API_URL_SPRING_BASE+"/searchCaseNumber"
  public readonly CASE_JSON_HTML = this.API_URL_SPRING_BASE+"/partitionFileJson"
  public readonly STORE_CATALOG= this.API_URL_SPRING_BASE+"/storeCatalog"
  public readonly RETRIEVE_ARISj_CATALOG_CSV= this.API_URL_SPRING_BASE+"/retrieveARISjCatalogCsv"
  public readonly RETRIEVE_ARISg_CATALOG_CSV= this.API_URL_SPRING_BASE+"/retrieveARISgCatalogCsv"
  public readonly GET_MATCHING_CASE = this.API_URL_SPRING_BASE+"/getMatchingCase"

  public readonly GET_AUDIT_MATCHING_CASE= this.API_URL_SPRING_BASE+"/getAuditTrailMatchingCase"
  public readonly AUDIT_TRAIL_HTML = this.API_URL_SPRING_BASE+"/auditTrailCsvTohtml"
  public readonly STORE_AUDIT_CATALOG = this.API_URL_SPRING_BASE+"/storeAuditCatalog"

  public readonly REFRESH_CASE_CATALOG = this.API_URL_SPRING_BASE+"/refreshCaseCatalog"


   public readonly RETRIEVE_S3_PATH = this.API_URL_SPRING_BASE+"/retrieveS3Path"
   public readonly BUILD_PROJECT = this.API_URL_SPRING_BASE+"/buildProject"
   public readonly CHECKOUT_FILES = this.API_URL_SPRING_BASE+"/checkoutFiles"
   public readonly GET_DETAILS_BY_ID = this.API_URL_SPRING_BASE+"/getDetailsById"
   public readonly RETRIEVE_DNSNAME = this.API_URL_SPRING_BASE+"/retrieveTargetDnsNameByEnvName";

   public readonly REFRESH_DATASET = this.API_URL_SPRING_BASE + '/generateDataset';
   public readonly RETRIEVE_OBJECT_LABLES = this.API_URL_SPRING_BASE+"/retrieveObjects"
   public readonly RETRIEVE_ALIAS = this.API_URL_SPRING_BASE+"/getAttributesWithObject"
   public readonly DELETE_FILTER_RECORD = this.API_URL_SPRING_BASE+"/deleteFilterRecord"

  // mapping file generation (vault object group screen)

  public readonly GENERATE_MAPPING_FILE = this.API_URL_SPRING_BASE + '/generateMappingFile';


   public readonly RETRIEVE_SOURCE_DNS = this.API_URL_SPRING_BASE + '/retrieveSourceDnsByUserId';
  public readonly RETRIEVE_SOURCE_DNS_BY_WORKSPACEID = this.API_URL_SPRING_BASE + '/retrieveSourceDnsByWorkspaceId';  
   public readonly RETRIEVE_OBJECTS_BY_DNS = this.API_URL_SPRING_BASE + '/retrieveObjectsByDns';
   public readonly RETRIEVE_DNS_BY_OBJECT = this.API_URL_SPRING_BASE + '/retrieveDnsByObjects';

  public readonly RETRIEVE_ALL_OBJECTGROUPNAME_FOR_DATASET= this.API_URL_SPRING_BASE+"/retrieveAllObjectGroupForDataset";
  public readonly RETRIEVE_TABLES_FIELDS_FOR_DATASET = this.API_URL_SPRING_BASE + '/retrieveReportingTableFieldsById';

  public readonly INSERT_DELETION_MIGRATION = this.API_URL_SPRING_BASE+"/insertMigrationForDeletion"

  public readonly RETRIEVE_DETECT_OBJECT_CHANGES_HISTORY = this.API_URL_SPRING_BASE+"/detectObjectChangesHistory";

  public readonly RETRIEVE_VAULT_OBJECT_CHANGES =   this.API_URL_SPRING_BASE+"/retrieveVaultObjectChanges";

  public readonly DETECT_VAULT_OBJECTS_CHANGES = this.API_URL_SPRING_BASE + "/detectVaultObjectChanges"

  public readonly RETRIEVE_VAULT_OBJECT_CHANGES_DETECT_STATUS = this.API_URL_SPRING_BASE+"/objectChangesDetectStatus";

  public readonly IMPORT_VAULT_CHANGES = this.API_URL_SPRING_BASE + "/importVaultChanges"

  public readonly GET_UNIQUECOLUMN_DATA_FROM_S3 = this.API_URL_SPRING_BASE +"/getUniqueColumnsData"

  public readonly GET_DATA_FROM_S3_EXTERNAL_TABLE = this.API_URL_SPRING_BASE +"/getMatchingRowsFromExternalTables"
  public readonly GET_ALL_ROWS_DATA_FROM_S3_FILE = this.API_URL_SPRING_BASE +"/getAllRowsFromS3File"

  public readonly GET_OBJECTMETADATA_BY_DNSID_CATEGORY = this.API_URL_SPRING_BASE +"/getObjectListByDnsidAndCategory"
  
  public readonly IMPORT_DATASETS = this.API_URL_SPRING_BASE+"/importDataset"
  
  public readonly EXPORT_DATASETS = this.API_URL_SPRING_BASE+"/ExportData"

  public readonly RETRIEVE_IMPORT_HISTORY =   this.API_URL_SPRING_BASE+"/importhistory";

  // public readonly RETRIEVE_IMPORT_EXPORT_HISTORY = this.API_URL_SPRING_BASE + "/importhistory";

  public readonly UPDATE_DATASET_VISUALS=this.API_URL_SPRING_BASE+"/updateDatasetVisual"
  public readonly UPDATE_DATASET_COLUMNS_VISUALS=this.API_URL_SPRING_BASE+"/updateDatasetColumnsVisualUrl";

  public readonly REFRESH_FACET = this.API_URL_SPRING_BASE + '/generateFacets';

  public readonly CREATE_MANAGE_VISUALS = this.API_URL_SPRING_BASE + '/insertVisuals';
  public readonly RETRIEVE_MANAGE_VISUALS = this.API_URL_SPRING_BASE + '/retrieveAllManageVisuals';
  public readonly DELETE_MANAGE_VISUALS = this.API_URL_SPRING_BASE + '/deleteManageVisualsByVisualId';
  public readonly RETRIEVE_MANAGE_VISUALS_ON_DATASET_ID = this.API_URL_SPRING_BASE + '/retrieveManageVisualsByDataSetId';
  

  //retriving the screenoperations permission
  public readonly Retrivescreenoperationspermission =this.API_URL_SPRING_BASE + '/screenoperationspermission';


  public readonly RETRIEVE_RECORDS_FOR_PURGING = this.API_URL_SPRING_BASE + '/retrieveRecordsOfPurge';

  public readonly SAVE_PURGE_DATA = this.API_URL_SPRING_BASE + '/savePurgeData';

  public readonly RETRIEVE_PURGE_RECORDS = this.API_URL_SPRING_BASE + '/retrievePurgeRecord';

  public readonly RETRIEVE_TABLE_RECORDS = this.API_URL_SPRING_BASE +'/retrieveAllRecordsBasedOnGroupName';

  public readonly DELETE_PURGE_RECORD = this.API_URL_SPRING_BASE + '/deletePurgeRecord'

  public readonly commonRetrieveSingleRecordAuth = this.API_URL_SPRING_BASE +'/retrieveMigrationTraceNewGrid';


   public readonly RETRIEVE_ACCESS_TOKEN= this.API_URL_SPRING_BASE + '/retrieveuserguidetoken'
   
   public readonly RETRIEVE_OBJECTID_BY_OBJECTNAME = this.API_URL_SPRING_BASE+'/objectIdByObjectName'


  // public readonly RETRIEVE_ACCESS_TOKEN= this.API_URL_SPRING_BASE + '/retrieveuserguidetoken';

   
   //Mapping Configuration
   public readonly RETRIEVE_DNS_ID_BASED_ON_ENV_NAME = this.API_URL_SPRING_BASE+"/retrieveDnsidBasedOnEnvName";
    public readonly INSERT_MAPPING_CONFIGURATION = this.API_URL_SPRING_BASE + "/insertMappingConfiguration";
    public readonly RETRIEVE_MAPPING_CONFIGURATION = this.API_URL_SPRING_BASE + "/retrieveMappingConfiguration";
    public readonly RETIRVE_SOURCE_OR_TARGET = this.API_URL_SPRING_BASE + "/checkSourceOrTarget"
    public readonly UPDATE_MAPPING_CONFIGURATION = this.API_URL_SPRING_BASE + "/updateMappingConfiguration"
    public readonly DELETE_MAPPING_CONFIGURATION = this.API_URL_SPRING_BASE + "/deleteMappingConfiguration"
    public readonly CAN_MODIFY_OR_DELETE = this.API_URL_SPRING_BASE + "/canModifyOrDelete"


   public readonly RETRIEVE_DETAILS_OF_SCREEN_BASED_DNSNAME = this.API_URL_SPRING_BASE + '/retrievedetailsofscreenbasedondnsname'
   public readonly RETRIEVEDNSID = this.API_URL_SPRING_BASE + '/retrievednsid'

   public readonly RETRIEVE_GROUP_OBJECTS_BASED_DNS = this.API_URL_SPRING_BASE + '/retrieveObjectsByDns'

   public readonly INSERT_STAGE_OBJECT_URL = this.API_URL_SPRING_BASE + "/insertStageObject";

   public readonly RETRIEVE_STAGE_OBJECT_URL = this.API_URL_SPRING_BASE + "/retrievestageobject"

   public readonly DELETE_STAGE_OBJECT = this.API_URL_SPRING_BASE + "/deletestageobject"

   public readonly RETIRVE_SOURCE_OR_NOT = this.API_URL_SPRING_BASE + "/checkIfSource"

   public readonly RETRIEVE_DNS_BASED_USER = this.API_URL_SPRING_BASE +"/retrievednsbasedonuser"

   public readonly RETRIEVEDNSID_BASED_ON_ENVNAME = this.API_URL_SPRING_BASE +"/retrievednsidbasedonenvname"
  
   public readonly CREATE_MAPPING_ATTRIBUTES = this.API_URL_SPRING_BASE + '/createmappingattributes';
   public readonly RETRIEVE_MAPPING_ATTRIBUTES = this.API_URL_SPRING_BASE +"/retrievemappingattributes"
   public readonly DELETE_MAPPING_ATTRIBUTES = this.API_URL_SPRING_BASE +"/deletemappingattributes";
   public readonly VALIDATE_SQL_QUERY = this.API_URL_SPRING_BASE +"/validateSQL";

   public readonly UPLOAD_MAPPING_EXCEL_FILE = this.API_URL_SPRING_BASE + "/getMappingfileForBussinesslogic"
    public readonly RETRIEVE_FUNCTIONAL_MAPPING = this.API_URL_SPRING_BASE +"/retrieveFunctionalMapping"
    public readonly EDIT_FUNCTIONAL_MAPPING = this.API_URL_FLASK_URL + "/record"




   //MigrationConfigration screen
   public readonly RetriveMigrationCongifration = this.API_URL_SPRING_BASE + '/retrieveValuesForMigrationConfiguration';
   public readonly insertMigrationCongifration = this.API_URL_SPRING_BASE + '/insertForMigrationConfiguration';
   public readonly deleteFromMigrationCongifration = this.API_URL_SPRING_BASE + '/deleteForMigrationConfiguration';


   // CIOMS and MedWatch comparison
   public readonly generateCompareReport = this.API_URL_SPRING_BASE+'/generateCompareReport'
   public readonly retrieveAllReports = this.API_URL_SPRING_BASE+'/retrieveAllReports'
   public readonly existingCiomsReportName = this.API_URL_SPRING_BASE+'/retrieveExistingReportName'
   public readonly downloadCiomReport = this.API_URL_SPRING_BASE+'/downloadCiomsMedWatchReport'

   public readonly ETL_OBJECT_COUNT_SUMMARY = this.API_URL_SPRING_BASE + '/retrieveETLObjectDetailsCount';
   public readonly ETL_MIGRATION_COUNT_SUMMARY = this.API_URL_SPRING_BASE + '/retrieveETLJobDetailsCount';
   public readonly LOAD_OBJECTS_COUNT_SUMMARY = this.API_URL_SPRING_BASE + '/retrieveLoadObjectDetailsCount';

   public readonly RETRIVE_SNAPSHOT_DETAILS = this.API_URL_SPRING_BASE + '/retrieveMappingBaselineDetails'
   public readonly GET_MAPPING_FILE_FROM_SNAPSHOT = this.API_URL_SPRING_BASE + '/retrieveMappingFromSnapshot'
   public readonly GET_MAPPING_FILE = this.API_URL_SPRING_BASE + '/retrieveMappingFileBased'
   public readonly UPDATE_MAPPINGFILEVERSION = this.API_URL_SPRING_BASE + '/retrieveMappingfileversion'
   public readonly GENERATE_NEW_MAPPING_FILE_VERSION = this.API_URL_SPRING_BASE +"/generateMappingFileVersion";
   public readonly GET_MAPPING_BASELINE_DETAILS = this.API_URL_SPRING_BASE +"/retrieveMappingBaselineDetails";
   public readonly RETRIEVE_MAPPING_TYPES = this.API_URL_SPRING_BASE + '/retrieveMappingTypesByTenantId';
   public readonly SAVE_MAPPING_TYPE = this.API_URL_SPRING_BASE + '/createMappingTypes';
   public readonly DELETE_MAPPING_TYPES = this.API_URL_SPRING_BASE +'/deleteMappingTypes';
   public readonly UpdateAttributeStatus = this.API_URL_SPRING_BASE +'/UpdateAttributeStatus';

     public readonly RETRIEVE_FIELD_MAPPING_BY_MAPPINGTYPE = this.API_URL_SPRING_BASE +"/retrieveFieldMappingByMappingTypeId"

  public readonly CREATE_FIELD_MAPPING_BY_MAPPINGTYPE = this.API_URL_SPRING_BASE +"/createFieldMapping"




  //Mappingtestbedscreen
  public readonly RetriveMigrationtestbed = this.API_URL_SPRING_BASE + '/retrieveMappingtestbedBasesOnMigrationid';
  public readonly insertMigrationtestbed = this.API_URL_SPRING_BASE + '/insertForMappingtestbed';
  public readonly deleteFromMigrationtestbed = this.API_URL_SPRING_BASE + '/deleteForMappingtestbed';
  public readonly RetriveMigrationtestbedBasedOnMigrationId = this.API_URL_SPRING_BASE + '/retrieveValuesFormMappingtestbedAndtrace';
  public readonly deleteFromMigrationtestbedbasedonMigrationid = this.API_URL_SPRING_BASE + '/deleteForMappingtestbed';
  public readonly retrivemappingtestbedforattribute = this.API_URL_SPRING_BASE +'/retrieveValuesForMappingtestbed';
  public readonly uploadfile = this.API_URL_SPRING_BASE + '/importFilestestbed'
  
  //
  
  public readonly insertIntoTestBedExecution = this.API_URL_SPRING_BASE +'/insertIntoTestBedExecution';
  public readonly retriveJsonData = this.API_URL_SPRING_BASE+'/retriveTestBedExecutionRecords';
   

      ///////User Specific Filter
      public readonly insertUserSpecificFilter = this.API_URL_SPRING_BASE+'/insertManageFilterByUser';
      public readonly retrieveUserSpecificFilter = this.API_URL_SPRING_BASE+'/retrieveManageFilterByUser';
      

     public readonly RETRIEVES_DNS_INFO =  this.API_URL_SPRING_BASE+"/retieveDnsInfo"
    public readonly COPYDATAFROMSOURCETOTARGET = this.API_URL_SPRING_BASE+"/insertRecordsFromSourceToTarget"
  

      public readonly UPLOADFILEFORVAULTOBJECTRELATIONSHIP = this.API_URL_SPRING_BASE+'/uploadVaultObjectRelationshipFile'
        public readonly RETRIEVE_VAULT_SESSION= this.API_URL_SPRING_BASE+'/vaultLoader/session'

        public readonly VALIDATE_OTP= this.API_URL+'/validateOTPUrl'
        public readonly RESEND_OTP= this.API_URL+'/resendOTPUrl'
          public readonly OTP_LOGIN = this.API_URL + "/signinOTPUrl"

        public readonly CHECK_TEMPLATE_PERMISSION = this.API_URL_SPRING_BASE + '/CheckTemplatePermission';


        public readonly GET_PRR = this.API_URL_SPRING_BASE + '/getResults';

        public readonly GET_ALL_DRUGS = this.API_URL_SPRING_BASE + '/getAllDrugs/search';
         public readonly GET_ALL_ADE = this.API_URL_SPRING_BASE + '/getAdverseEvents/search';


        public readonly UPLOADFILEFOROBJECTMETADATA = this.API_URL_SPRING_BASE + '/uploadFileForObjects';


        public readonly RETRIEVE_DETAILS_BASED_ON_DNSNAME = this.API_URL_SPRING_BASE + '/getDataByDns';

        public readonly BATCH_INSERT_MAPPING_CONFIGURATION = this.API_URL_SPRING_BASE + '/batchInsertion';


        public readonly UPLOADFILEFORATTRIBUTEMAPPING = this.API_URL_SPRING_BASE + '/batchInsertionOfAttributesMapping';

        public readonly RETRIEVE_NON_STAGE_OBJECTS_BASED_DNS = this.API_URL_SPRING_BASE + '/retrieveNonStageObjectsByDns';
        
        public readonly retrivemappingtestbedexecution = this.API_URL_SPRING_BASE + '/retrieveMappingTestBedExecution';

        public readonly RETRIEVE_SQl_BASED_ON_BUSSINESS_LOGIC = this.API_URL_SPRING_BASE + '/retrieveBussinessLogic'

        public readonly UpdateobjectmetadataStatus = this.API_URL_SPRING_BASE + '/UpdateobjectmetadataStatus';

        public readonly RETRIEVEOBJECTSFROMOBJECTMETADATA = this.API_URL_SPRING_BASE + '/retrieveObjectmetadata'

        public readonly GET_DEFAULT_TEMPLATE = this.API_URL_SPRING_BASE + '/product-strategy-temp';


        public readonly INSERT_PASSWORD_POLICY = this.API_URL_SPRING_BASE + '/insertPasswordPolicy';
        
        public readonly RETRIEVE_PASSWORD_POLICIES = this.API_URL_SPRING_BASE +'/retrievePasswordPolicies';

        public readonly DELETE_PASSWORD_POLICIES = this.API_URL_SPRING_BASE + '/deletePasswordPolicy';


        public readonly GET_PRODUCT_LIST = this.API_URL_SPRING_BASE + '/product-strategy/getProductList';

        public readonly GET_PRODUCT_METADATA = this.API_URL_SPRING_BASE + '/product-strategy/products';

        public readonly CREATE_STRATEGY = this.API_URL_SPRING_BASE + '/product-strategy/create';

         public readonly GET_ALL_STRATEGY = this.API_URL_SPRING_BASE + '/product-strategy/get';

         public readonly UPDATE_STRATEGY = this.API_URL_SPRING_BASE + '/product-strategy/update';

         public readonly DELETE_STRATEGY = this.API_URL_SPRING_BASE + '/product-strategy/delete';

         public readonly CREATE_TEMPLATE = this.API_URL_SPRING_BASE + '/product-strategy-temp/create';

         public readonly GETALL_TEMPLATE_NONDEFAULT = this.API_URL_SPRING_BASE + '/product-strategy-temp/get/non-default';

         public readonly UPDATE_TEMPLATE = this.API_URL_SPRING_BASE + '/product-strategy-temp/update';

         public readonly DELETE_TEMPLATE = this.API_URL_SPRING_BASE + '/product-strategy-temp/delete';

         public readonly GETALL_TEMPLATE = this.API_URL_SPRING_BASE + '/product-strategy-temp/get';

         public readonly GET_UNIQUE_TEMPLATE_NAME = this.API_URL_SPRING_BASE + '/product-strategy-temp/check-name';


          public readonly GET_PSS_FOR_REVIEW = this.API_URL_SPRING_BASE + '/product-strategy/{userId}/documents-in-review';

          public readonly APPROVER_ACTION = this.API_URL_SPRING_BASE + '/product-strategy/{Id}/complete-approve';

         public readonly UPLLOADFILEFORSTAGEOBJECTS = this.API_URL_SPRING_BASE + '/insertStageObjectsBatch';

          public readonly REAUTHENTICATE = this.API_URL + '/reAuthentication'

         public readonly GET_PSS_BY_ID = this.API_URL_SPRING_BASE + '/product-strategy/getByStrategyId';


         //added by kameshwar.d @date 09-09-2025
          public readonly UPLOAD_TEMPLATES = this.API_URL_SPRING_BASE + '/product-strategy-temp/upload';
          
          public readonly DOWNLOAD_TEMPLATES = this.API_URL_SPRING_BASE + '/product-strategy-temp/download-zip';
           public readonly RETRIEVE_OBJECTS_BY_MULTIPLE_DNS = this.API_URL_SPRING_BASE + '/retrieveObjectfromMultipleDns';

          //added by Rahul Vk @date 15/09/25
          public readonly ADD_NEW_COMMENT = this.API_URL_SPRING_BASE + '/product-strategy/addComment';

           public readonly DELETE_COMMENT = this.API_URL_SPRING_BASE + '/product-strategy/deleteComment';

           public readonly EDIT_COMMENT = this.API_URL_SPRING_BASE + '/product-strategy/editComment';

           public readonly REPLY_TO_COMMENT = this.API_URL_SPRING_BASE + '/product-strategy/replyComment';

           public readonly UPDATE_COMMENT_STATUS = this.API_URL_SPRING_BASE + '/product-strategy/updateCommentStatus';

           public readonly GET_COMMENTS = this.API_URL_SPRING_BASE + '/product-strategy/getComments';

           public readonly REVIEWE_COMPLETE = this.API_URL_SPRING_BASE + '/product-strategy/{Id}/complete-review';


           public readonly GET_SECTION = this.API_URL_SPRING_BASE + '/product-strategy/section';

           public readonly GET_ALL_SCHEDULED_REVIEW_ACTIVITIES = this.API_URL_SPRING_BASE + '/product-strategy/review-activities/{userId}/{workSpaceId}';

           public readonly SELF_ASSIGN_USER_TO_ACTIVITY = this.API_URL_SPRING_BASE + '/product-strategy/review-activities';

            public readonly REMOVE_ASSIGNED_USER_TO_ACTIVITY = this.API_URL_SPRING_BASE + '/product-strategy/review-activities';

            public readonly START_REVIEW_ACTIVITY = this.API_URL_SPRING_BASE + '/product-strategy/review-activities';

           public readonly COMPLETE_REVIEW_ACTIVITY = this.API_URL_SPRING_BASE + '/product-strategy/{scheduleId}/completeReview';

          public readonly GET_OBJECTS_WITH_OBJECTGROUP = this.API_URL_SPRING_BASE + '/retrieveObjectsToExtractBasedOnGroupName';

          public readonly RETRIEVE_OBJECTS_ON_OBJECT_GROUP = this.API_URL_SPRING_BASE + '/retrieveAllObjectsToExtractBasedOnGroupName';
  
          public readonly UPLOADSNAPSHOT = this.API_URL_SPRING_BASE+"/uploadSnapshot";

  public readonly DELETE_MULTIPLE_MAPPING_ATTRIBUTES = this.API_URL_SPRING_BASE + "/deletemultiplemappingattributes"
  
  public readonly EXPORT_JSON = this.API_URL_SPRING_BASE + "/importExport"
  
  public readonly IMPORT_JSON = this.API_URL_SPRING_BASE + "/import"
  public readonly IMPORT_SNAPSHOT_ZIP = this.API_URL_SPRING_BASE + "/importSnapShot"
  public readonly EXPORT_SNAPSHOT_ZIP = this.API_URL_SPRING_BASE + "/exportSnapShot"


  public readonly RETRIEVE_SOURCE_EXTRACTION_QUERIES = this.API_URL_SPRING_BASE + "/retriveSourceDataExtractionQueries";
  public readonly INSERT_SOURCE_DATA_EXTRACTION_QUERIES = this.API_URL_SPRING_BASE + "/sourceDataExtractionQueries";
  public readonly DELETE_SOURCE_EXTRACTION_QUERIESS = this.API_URL_SPRING_BASE + "/delete"
  public readonly DATASOURCENAMES = this.API_URL_SPRING_BASE + "/datasourcenames"

  public readonly GET_LATEST_APPROVED_PSS = this.API_URL_SPRING_BASE + "/product-strategy/unique-StrategiesNames"

  public readonly DELETE_AD_HOC_ACTIVITY = this.API_URL_SPRING_BASE + "/product-strategy/review-activities/delete/{id}"

  public readonly DOWNLOAD_DOCUMNET_FOR_APPROVED_LATEST_PSS = this.API_URL_SPRING_BASE + "/product-strategy/downloadDocument/{strategyId}"

  public readonly RETRIEVE_OBJECTS_ON_OBJECT_GROUP_TENANTID = this.API_URL_SPRING_BASE + "/retrieveObjectsBasedOnObjectGroup"
  public readonly RETRIEVE_OBJECTS_ON_OBJECT_GROUP_ID = this.API_URL_SPRING_BASE + '/retrieveObjectsDetailsByGroupId';
    public readonly getMedradata = this.API_URL_SPRING_BASE + "/meddra/data"
   public readonly getMedrachilders = this.API_URL_SPRING_BASE + "/meddra/children"
  public readonly getMedraVersions = this.API_URL_SPRING_BASE + "/meddra/versions"

 public readonly RETRIEVE_DNSID_BY_NAME = this.API_URL_SPRING_BASE+'/getDnsId'
  public readonly GET_HELP_LINK = this.API_URL_SPRING_BASE + "/getHelpLink";
  
  public readonly GET_SCREEN_ID = this.API_URL_SPRING_BASE + "/getScreenId";
  public readonly RETRIEVE_DOCUMENT_VERSION = this.API_URL_SPRING_BASE+"/retrieveDocumentLatestVersion";
  public readonly RETRIEVE_DOCUMENTS_VERSION = this.API_URL_SPRING_BASE+"/retrieveDocumentVersions";
  public readonly LOGINTYPE = this.API_URL + "/loginType";

  // Added by Rahul vk on 24-10-2024
  public readonly getMedrasearchdata = this.API_URL_SPRING_BASE + "/meddra";

  public readonly createMeddraBasket = this.API_URL_SPRING_BASE + "/meddrabaskets/create";

  public readonly GetMEDRABASKETS_OF_SELECTED_MEDDRA_VERSION = this.API_URL_SPRING_BASE + "/meddrabaskets/names";

  public readonly ADD_TERMS_TO_SELCTED_BASKET = this.API_URL_SPRING_BASE + "/meddrabaskets/{basketId}/{dataType}/terms";

  public readonly GET_BASKET_DETAILS = this.API_URL_SPRING_BASE + "/meddrabaskets/{basketId}/details";

      public readonly UPDATE_BASKET_STATE = this.API_URL_SPRING_BASE + "/meddrabaskets/{basketId}/state";
  //Manage MDL Script Screen
  public readonly RETRIEVE_JSUITE_CATEGORY = this.API_URL_SPRING_BASE+"/retrieveAllJsuitePropertyCategory/{lookupType}";
  public readonly RETRIEVE_JSUITE_PROPERTIES = this.API_URL_SPRING_BASE+"/retrieveJsuitePropertiesOnProductCategory/{lookupValue}";
  public readonly RETRIEVE_COMPONENT_TYPE = this.API_URL_SPRING_BASE+"/retrieveAllComponentMetaData/{dnsName}";
  public readonly INSERT_MANAGE_MDL_SCRIPT = this.API_URL_SPRING_BASE + "/manageMdlscript";
  public readonly RETRIEVE_MANAGE_MDL_SCRIPT = this.API_URL_SPRING_BASE + "/retrieveAllManageMDLScript";
  public readonly DELETE_MANAGE_MDL_SCRIPT = this.API_URL_SPRING_BASE + "/updateMDLScriptStatus/{status}/{manageMDLScriptId}";
    public readonly EXECUTE_MDL_SCRIPT = this.API_URL_SPRING_BASE+"/executeMDLScript/{dnsName}/{id}";
        public readonly UPDATE_JSUITE_PROPERTIES = this.API_URL_SPRING_BASE+"/updateJsuiteProperties";


public readonly RETRIEVE_Exception_Queries = this.API_URL_SPRING_BASE + '/retrieveExceptionQueries';
public readonly INSERT_Exception_Queries = this.API_URL_SPRING_BASE + '/exceptionquery';
public readonly DELETE_Exception_Queries = this.API_URL_SPRING_BASE + '/exceptionquery/{id}'

  public readonly RESET_PASSWORD_CONFIRMATION = this.API_URL + "/selectUserForReset";



      public readonly GET_MIGRATION_TYPE = this.API_URL_SPRING_BASE + "/getMigrationType/";

      public readonly RETRIEVE_USERNAME_BASED_ON_SESSION = this.API_URL  + "/userBasedOnSession"


      
    public readonly RETRIEVE_MAPPING_CONFIGURATION_OBJECTS = this.API_URL_SPRING_BASE + "/retrieveSourceTargetObjects";

    public readonly RETRIEVE_MAPPED_ATTRIBUTES = this.API_URL_SPRING_BASE + "/retrieveMappedAttributes";



// Added By Rahul Vk on 30-12-2025 for Deviation Management APIs
public readonly CREATE_DEVIATION = this.API_URL_SPRING_BASE+"/Deviation/createDeviation/{workspaceId}/{dnsId}/{deviationFor}/{uniqueRecordId}";

public readonly GET_ALL_ACTIVE_DEVIATION = this.API_URL_SPRING_BASE+"/Deviation/getAllActiveDeviations";

public readonly UPDATE_DEVIATION = this.API_URL_SPRING_BASE+"/Deviation/updateDeviation/{id}";

public readonly DELETE_DEVIATION = this.API_URL_SPRING_BASE+"/Deviation/deleteDeviationById/{deviationId}";

public readonly GET_DEVIATION_DETAILS_BY_ID = this.API_URL_SPRING_BASE+"/Deviation/getDeviation/{id}";

public readonly CLOSE_DEVIATION = this.API_URL_SPRING_BASE + "/Deviation/{id}/close";

public readonly SOFT_DELETE_DEVIATION =this.API_URL_SPRING_BASE + "/Deviation/{id}/deleteDeviation";

public readonly GET_ROOT_CAUSES_BY_DEVIATION_ID =this.API_URL_SPRING_BASE + "/Deviation/{deviationId}/root-causes";

public readonly ADD_ROOT_CAUSES =this.API_URL_SPRING_BASE + "/Deviation/{deviationId}/add/root-causes";

public readonly UPDATE_ROOT_CAUSE =this.API_URL_SPRING_BASE + "/Deviation/{deviationId}/updateRootCauses/{rootCauseId}";

public readonly DELETE_ROOT_CAUSE =this.API_URL_SPRING_BASE + "/Deviation/{deviationId}/DeleteRootCauses/{rootCauseId}";

public readonly GET_CAPAS_BY_DEVIATION_ID =this.API_URL_SPRING_BASE + "/Deviation/{deviationId}/capas";

public readonly ADD_CAPAS =this.API_URL_SPRING_BASE + "/Deviation/{deviationId}/add/capas";

public readonly UPDATE_CAPA =this.API_URL_SPRING_BASE + "/Deviation/{deviationId}/updateCapas/{capaId}";

public readonly DELETE_CAPA =this.API_URL_SPRING_BASE + "/Deviation/{deviationId}/deleteCapas/{capaId}";


    public readonly RETRIEVE_COMPLETED_LOADSETS = this.API_URL_SPRING_BASE + "/retrieveCompletedLoadSets";
      
    public readonly SAVE_REMIGRATE_MAPPING_AND_OBJECTS = this.API_URL_SPRING_BASE+ "/saveRemigrateMappingAndObjects"
public readonly RETRIEVEOBJECTIDDBSTATUSOFLEVEL = this.API_URL_SPRING_BASE+"/retrieveObjectIDDBStatusOfLevel";
public readonly RETRIEVE_LOOKUP_VALUE_BY_LOOKUPTYPE = this.API_URL_SPRING_BASE+"/retrieveLookupValueByLookupType";

public readonly GET_ALL_DEVIATIONS = this.API_URL_SPRING_BASE+"/Deviation/deviation-management";

public readonly GET_DEVIATION_DETAILS = this.API_URL_SPRING_BASE+"/Deviation/{id}/DeviationDetails";

public readonly GET_DEVIATION_METADATA = this.API_URL_SPRING_BASE+"/Deviation/{id}/Deviation-metadata";

public readonly getMedDRASMQs = this.API_URL_SPRING_BASE + "/meddra/smqs";
public readonly getMedDRASMQsleaf = this.API_URL_SPRING_BASE + "/meddra/smqs/leaf";
public readonly getMedDRASMQsByPtTerms = this.API_URL_SPRING_BASE + "/meddra/smqs/by-pt";

public readonly RETRIEVE_LOAD_OBJECTS_MSTR = this.API_URL_SPRING_BASE + "/retrieveLoadObjectsFromLoadObjectsmstr";
public readonly INSERT_LOAD_OBJECTS_MSTR = this.API_URL_SPRING_BASE + "/loadObjectsMstr";
public readonly DELETE_LOAD_OBJECTS_MSTR = this.API_URL_SPRING_BASE + "/deleteloadObjectsMstr";
public readonly RETRIEVE_SELF_REFERENCE_FILENAMES = this.API_URL_SPRING_BASE + "/loadObjectsMstr/selfReferenceFiles";
public readonly GET_TARGET_ATTRIBUTES = this.API_URL_SPRING_BASE + "/getTargetAttributes";
public readonly CREATE_ALERTRULE = this.API_URL_SPRING_BASE + "/alertRule/create";
public readonly UPDATE_ALERTRULE = this.API_URL_SPRING_BASE + "/alertRule/update/{id}";
public readonly DELETE_ALERTRULE = this.API_URL_SPRING_BASE + "/alertRule/delete/{id}";
public readonly GET_ALL_ALERT_RULE = this.API_URL_SPRING_BASE + "/alertRule/getAll";
public readonly GET_ALERT_RULE_BY_ID = this.API_URL_SPRING_BASE + "/alertRule/{id}";
  object: any;
public readonly OBJECT_PAGE_LAYOUTS = this.API_URL_SPRING_BASE + '/object-page-layouts';

public readonly RETRIEVE_QUICKSIGHT_DASHBOARD = this.API_URL_SPRING_BASE + "/getDashBoardById";

public readonly RETRIEVELOADACTIONOFMIGRATIONTRACE=this.API_URL_SPRING_BASE+"/retrieveLoadActionOfMigrationTrace"

public readonly getKeyChangesByDate = this.API_URL_SPRING_BASE + "/product-strategy/filter";

  public readonly GET_SIGNAL_DETECTED_PRODUCT = this.API_URL_SPRING_BASE + '/product-strategy/signalDetected-products';
  
  public readonly CREATE_LIFECYCLE_CONFIGURATION = this.API_URL_SPRING_BASE + '/lifecycle';

  public readonly GET_LIFECYCLE_DETAILS = this.API_URL_SPRING_BASE + '/lifecycle';


  public readonly DELETE_LIFECYCLE = this.API_URL_SPRING_BASE + '/lifecycle';

  public readonly GET_REPORT_CREATION_BY_ID = this.API_URL_SPRING_BASE +'/retrieveReportCreation';
  public readonly createAction = this.API_URL_SPRING_BASE + "/actions";
  public readonly updateAction = this.API_URL_SPRING_BASE + "/actions";
  public readonly getActionById = this.API_URL_SPRING_BASE + "/actions";
  public readonly getAllActions = this.API_URL_SPRING_BASE + "/actions";
  public readonly deleteAction = this.API_URL_SPRING_BASE + "/actions";
  public readonly getActionsByExternalId = this.API_URL_SPRING_BASE + "/actions/external";
  public readonly updateActionState = this.API_URL_SPRING_BASE + "/actions/{id}/state";
  public readonly RETRIEVE_JEEV_OBJECTS = this.API_URL_SPRING_BASE + "/getAllObjects";
public readonly REFRESH_JEEV_OBJECTS = this.API_URL_SPRING_BASE + "/refreshObjects";
public readonly JEEV_OBJECTS_REFRESH_HISTORY = this.API_URL_SPRING_BASE + "/getObjectsRefreshHistory";
public readonly CREATE_JEEV_OBJECTS = this.API_URL_SPRING_BASE + "/createOrUpdate";
public readonly DELETE_JEEV_OBJECTS = this.API_URL_SPRING_BASE + "/deleteObjects";
public readonly RETRIEVE_LIFECYCLE = this.API_URL_SPRING_BASE + "/getAllLifecycle";
public readonly REFRESH_SINGLE_JEEV_OBJECT = this.API_URL_SPRING_BASE + "/refreshObject";
public readonly JEEV_OBJECT_REFRESH_STATUS = this.API_URL_SPRING_BASE + "/getRefreshStatus";
public readonly ATTRIBUTE_TYPES = this.API_URL_SPRING_BASE + "/getAttributeTypes";

  public readonly GET_WORKFLOWS = this.API_URL_SPRING_BASE + "/workflow";
  public readonly CREATE_WORKFLOW = this.API_URL_SPRING_BASE + "/workflow";
  public readonly DELETE_WORKFLOW = this.API_URL_SPRING_BASE + "/workflow"
public readonly GET_ALL_ALERT_PRODUCT_MAPPING = this.API_URL_SPRING_BASE + '/alertProductMapping/getAll';

public readonly GET_ALL_ACTIVE_ALERTS_RULES = this.API_URL_SPRING_BASE + '/alertProductMapping/getAllActiveAlerts';

public readonly MANUAL_MAP_SELECTED_PRODUCT_TO_ALERT_RULE = this.API_URL_SPRING_BASE + '/alertProductMapping/map';

public readonly MANUAL_UNMAP_SELECTED_PRODUCT_TO_ALERT_RULE = this.API_URL_SPRING_BASE + '/alertProductMapping/unmap';

  public readonly GET_ALERT_PRODUCT_MAPPING_SUMMARY = this.API_URL_SPRING_BASE + '/alertProductMapping/summary';
  
  public readonly CREATE_WORKFLOW_STEPS = this.API_URL_SPRING_BASE + '/workflowsteps'
  public readonly RETRIEVE_WORKFLOW_STEPS = this.API_URL_SPRING_BASE + '/workflowsteps'
  public readonly DELETE_WORKFLOW_STEPS = this.API_URL_SPRING_BASE + '/workflowsteps'
  public readonly CREATE_PLACEHOLDER_WORKFLOW_STEP = this.API_URL_SPRING_BASE + '/placeholderworkflowsteps'
  public readonly JSUITE_OBJECTS_BASED_ON_LIFECYCLE = this.API_URL_SPRING_BASE + '/jsuiteobjectsbylifecycle'



public readonly GET_USER_TASK = this.API_URL_SPRING_BASE + '/MyTask/{userId}';
public readonly CREATE_REVIEW_ACTIVITY_CONFIG = this.API_URL_SPRING_BASE + '/reviewActivityConfig/create';

public readonly GET_ALL_REVIEW_ACTIVITY_CONFIGS = this.API_URL_SPRING_BASE + '/reviewActivityConfig/getAll/{workSpaceId}';

public readonly GET_ALL_ACTIVE_REVIEW_ACTIVITY_CONFIGS = this.API_URL_SPRING_BASE + '/reviewActivityConfig/getAllActive/{workSpaceId}';

public readonly UPDATE_ACTIVE_REVIEW_ACTIVITY_CONFIG = this.API_URL_SPRING_BASE + '/reviewActivityConfig/update/{id}';

public readonly DELETE_ACTIVE_REVIEW_ACTIVITY_CONFIG = this.API_URL_SPRING_BASE + '/reviewActivityConfig/delete/{id}';

public readonly CREATE_SIGNAL_SOURCE_CONFIGURATION = this.API_URL_SPRING_BASE + '/SignalConfig/create';

public readonly UPDATE_SIGNAL_CONFIGURATION  = this.API_URL_SPRING_BASE + '/SignalConfig/update/{id}';

public readonly DELETE_SIGNAL_CONFIGURATION  = this.API_URL_SPRING_BASE + '/SignalConfig/delete/{id}';

public readonly GET_ALL_SIGNAL_SOURCES = this.API_URL_SPRING_BASE + '/SignalConfig/source';

public readonly GET_VALIDATION_SLA = this.API_URL_SPRING_BASE + '/SignalConfig/sla';

public readonly GET_TABLEORMODULE_FOR_IMPORTEXPORT = this.API_URL_SPRING_BASE + '/getScreenorModule';

public readonly REFRESH_CASE_AUDIT_EXTRACTION = this.API_URL_SPRING_BASE + "/caseAuditExtraction/refresh";
public readonly UPLOAD_CASE_AUDIT_EXTRACTION = this.API_URL_SPRING_BASE+ "/caseAuditExtraction/upload";
public readonly GET_PRODUCTS_FOR_ROLE = this.API_URL_SPRING_BASE + '/getProductsAssignedToRole';
public readonly INSERT_PRODUCTS_FOR_ROLE = this.API_URL_SPRING_BASE + '/insertProductsToRole';
public readonly GET_ASSIGNED_PRODUCTS_FOR_ROLE = this.API_URL_SPRING_BASE + '/getRoleAssignedProductList';
public readonly GET_OBJECT_ATTRIBUTES = this.API_URL_SPRING_BASE + "/object-attributes";
public readonly GET_OBJECT_NAMES = this.API_URL_SPRING_BASE + "/object-names";
public readonly CREATE_SIGNAL = this.API_URL_SPRING_BASE + '/Signal/create';

public readonly UPDATE_SIGNAL = this.API_URL_SPRING_BASE + '/Signal/update/{id}';

public readonly GET_ALL_SIGNAL = this.API_URL_SPRING_BASE + '/Signal/getAll';

public readonly DELETE_SIGNAL = this.API_URL_SPRING_BASE + '/Signal/delete/{id}';

public readonly ASSIGN_USER_TO_SIGNAL = this.API_URL_SPRING_BASE + '/Signal/{signalId}/assign-user/{userId}';

public readonly GET_SIGNAL_BY_ID = this.API_URL_SPRING_BASE + '/Signal/{id}';

public readonly CHANGE_SIGNAL_STATUS = this.API_URL_SPRING_BASE + '/Signal/{id}/status';

public readonly CREATE_SIGNAL_DECISION = this.API_URL_SPRING_BASE + '/Signal/signalDecision/create/{signalId}';

public readonly GET_ALL_SIGNAL_DECISIONS = this.API_URL_SPRING_BASE + '/Signal/signalDecision/getAll/{signalId}';

public readonly UPDATE_SIGNAL_DECISION = this.API_URL_SPRING_BASE + '/Signal/signalDecision/update/{id}';

public readonly DELETE_SIGNAL_DECISION = this.API_URL_SPRING_BASE + '/Signal/signalDecision/delete/{id}';

public readonly UPLOAD_SIGNAL_ATTACHMENTS = this.API_URL_SPRING_BASE + '/Signal/SignalAttachment/{signalId}/uploadAttachments';

public readonly DOWNLOAD_SIGNAL_ATTACHMENTS = this.API_URL_SPRING_BASE + '/Signal/SignalAttachment/downloadAttachment/{attachmentId}';

public readonly DELETE_SIGNAL_ATTACHMENTS = this.API_URL_SPRING_BASE + '/Signal/deleteAttachment/{attachmentId}';

public readonly GET_SIGNAL_ATTACHMENTS = this.API_URL_SPRING_BASE + '/Signal/SignalAttachment/{SignalId}';

public readonly GET_SIGNAL_LINKS = this.API_URL_SPRING_BASE + '/Signal/SignalAttachment/{signalId}/links';

public readonly GET_SIGNAL_COUNTS = this.API_URL_SPRING_BASE + '/Signal/signal-counts';

public readonly GET_ALL_MEETINGS = this.API_URL_SPRING_BASE + '/meetings/getAll';

public readonly CREATE_MEETING = this.API_URL_SPRING_BASE + '/meetings/create';

public readonly UPDATE_MEETING = this.API_URL_SPRING_BASE + '/meetings/update/{id}';

public readonly DELETE_MEETING = this.API_URL_SPRING_BASE + '/meetings/delete/{id}';

public readonly GET_MEETING_PARTICIPANTS = this.API_URL_SPRING_BASE + '/meetings/{id}/participants';

public readonly RETRIEVE_LIFECYCLE_STATES_BY_WORKFLOW_ID = this.API_URL_SPRING_BASE + '/workflow';
  
public readonly ADD_MEETING_PARTICIPANTS = this.API_URL_SPRING_BASE + '/meetings/{id}/participants/add';

public readonly REMOVE_MEETING_PARTICIPANTS = this.API_URL_SPRING_BASE + '/meetings/{id}/participants/remove';

 public readonly CREATE_HA_REQUEST = this.API_URL_SPRING_BASE + '/ha-request/create';
  public readonly GET_ALL_HA_REQUESTS = this.API_URL_SPRING_BASE + '/ha-request/list';
  public readonly UPDATE_HA_REQUEST = this.API_URL_SPRING_BASE + '/ha-request/update/{id}';
  public readonly DELETE_HA_REQUEST = this.API_URL_SPRING_BASE + '/ha-request/delete/{id}';
  public readonly GET_HA_REQUEST_BY_ID = this.API_URL_SPRING_BASE + '/ha-request/{id}';
// ================= SUB ACTION APIs =================

// Create SubAction under HA Request
public readonly CREATE_SUB_ACTION =
  this.API_URL_SPRING_BASE + '/ha-request/{requestId}/sub-actions';

// Update SubAction
public readonly UPDATE_SUB_ACTION =
  this.API_URL_SPRING_BASE + '/ha-request/sub-actions/{id}';

// Delete SubAction
public readonly DELETE_SUB_ACTION =
  this.API_URL_SPRING_BASE + '/ha-request/sub-actions/{id}';

// ================= ATTACHMENT APIs =================

// Upload File under HA Request
public readonly UPLOAD_ATTACHMENT_FILE =
  this.API_URL_SPRING_BASE + '/ha-request/{requestId}/attachments/file';

// Add Link under HA Request
public readonly ADD_ATTACHMENT_LINK =
  this.API_URL_SPRING_BASE + '/ha-request/{requestId}/attachments/link';

// Update Attachment (mainly for LINK rename/update)
public readonly UPDATE_ATTACHMENT =
  this.API_URL_SPRING_BASE + '/ha-request/attachments/{id}';

// ==================== ATTACHMENT ENDPOINTS ====================

// Delete Attachment (FILE or LINK) - Already exists
public readonly DELETE_ATTACHMENT = this.API_URL_SPRING_BASE + '/ha-request/attachments/{id}';

// Upload Multiple Files
public readonly UPLOAD_MULTIPLE_FILES = this.API_URL_SPRING_BASE + '/ha-request/{requestId}/attachments/files?dnsId={dnsId}';

// Upload Single File
public readonly UPLOAD_SINGLE_FILE = this.API_URL_SPRING_BASE + '/ha-request/{requestId}/attachments/file?dnsId={dnsId}';

// Download File Attachment
public readonly DOWNLOAD_FILE_ATTACHMENT = this.API_URL_SPRING_BASE + '/ha-request/attachments/{attachmentId}/download';

// Get All Attachments (Files + Links)
public readonly GET_ALL_ATTACHMENTS = this.API_URL_SPRING_BASE + '/ha-request/{requestId}/attachments';

// Get Only File Attachments
public readonly GET_FILE_ATTACHMENTS = this.API_URL_SPRING_BASE + '/ha-request/{requestId}/attachments/files';

// Get Only Link Attachments
public readonly GET_LINK_ATTACHMENTS = this.API_URL_SPRING_BASE + '/ha-request/{requestId}/attachments/links';

// Add Link Attachment
public readonly ADD_LINK_ATTACHMENT = this.API_URL_SPRING_BASE + '/ha-request/{requestId}/attachments/link';

public readonly ASSIGN_USER_TO_HA_REQUEST = this.API_URL_SPRING_BASE + '/ha-request/{requestId}/assign-user/{userId}';

public readonly GET_HA_REQUEST_SUMMARY= this.API_URL_SPRING_BASE + '/ha-request/summary';
public readonly GET_OBJECT_LABEL = this.API_URL_SPRING_BASE + "/getObjectLabel";

public readonly CREATE_PRODUCT_GROUP= this.API_URL_SPRING_BASE + '/insertProductGroup';

public readonly GET_PRODUCT_GROUP= this.API_URL_SPRING_BASE + '/getProductsGroups';

public readonly GET_PRODUCTS_BY_PRODUCT_GROUP_ID= this.API_URL_SPRING_BASE + '/getProductsMappedToProductGroup';

public readonly INSERT_PRODUCTS_BY_PRODUCT_GROUP_ID= this.API_URL_SPRING_BASE + '/insertProductsToProductGroup';

public readonly GET_PRODUCT_GROUPS_BY_ROLE= this.API_URL_SPRING_BASE + '/getProductsGroupMappedToRole';

public readonly INSERT_PRODUCT_GROUP_BY_ROLE= this.API_URL_SPRING_BASE + '/insertProductGroupByRole';

public readonly DELETE_PRODUCT_GROUP= this.API_URL_SPRING_BASE + '/deleteProductGroup';

public readonly GET_SIGNALS_BY_PRODUCTID = this.API_URL_SPRING_BASE + '/Signal/signalsOnProductId';

public readonly GET_SIGNAL_COUNT_BY_PRODUCTID = this.API_URL_SPRING_BASE + '/Signal/signal-counts-by-productid';

public readonly GET_ALL_SCHEDULED_REVIEW_ACTIVITIES_BY_DATERANGE = this.API_URL_SPRING_BASE + '/product-strategy/review-activities-daterange';
public readonly RETRIEVE_GROUP_OBJECTS_BASED_DNS_EXCLUDING_STAGE =this.API_URL_SPRING_BASE + '/retrieveObjectsByDNSExcludingStage';

public readonly CREATE_FORMULA = this.API_URL_SPRING_BASE + '/formulaBuilder/create';

public readonly GET_ALL_FORMULAS = this.API_URL_SPRING_BASE + '/formulaBuilder/getAll';

public readonly UPDATE_FORMULA= this.API_URL_SPRING_BASE + '/formulaBuilder/update/{id}';

public readonly GET_FORMULA_BY_ID= this.API_URL_SPRING_BASE + '/formulaBuilder/{id}';

public readonly DELETE_FORMULA= this.API_URL_SPRING_BASE + '/formulaBuilder/delete/{id}';


public readonly GET_OBJECT_GROUP_ID_BY_NAME = this.API_URL_SPRING_BASE + "/getObjectGroupIdByName";

public readonly GET_ALL_LIBRARY_PRODUCTS = this.API_URL_SPRING_BASE + "/library/getLibraryProducts";

public readonly GET_LIB_PRODUCT_DETAILS = this.API_URL_SPRING_BASE + "/library/getProductWithGroups/{productId}";

public readonly GET_ALL_LIBRARY_STUDY = this.API_URL_SPRING_BASE + "/library/getALLStudy";

public readonly GET_LIBRARY_STUDY_BY_ID = this.API_URL_SPRING_BASE + "/library/{studyId}/getStudyDetails";

public readonly GET_LIBRARY_STUDY_PRODUCTS_BY_ID = this.API_URL_SPRING_BASE + "/library/{studyId}/StudyProducts";

public readonly GET_LIBRARY_STUDY_ARMS_BY_ID = this.API_URL_SPRING_BASE + "/library/{studyId}/StudyArms";

public readonly GET_LIBRARY_STUDY_INDICATIONS_BY_ID = this.API_URL_SPRING_BASE + "/library/{studyId}/StudyIndications";

public readonly GET_LIBRARY_STUDY_REGISTRATIONS_BY_ID = this.API_URL_SPRING_BASE + "/library/{studyId}/StudyRegistrations";

public readonly GET_ALL_IME_RECORDS = this.API_URL_SPRING_BASE + "/library/getAllImeRecords";

public readonly GET_ALL_DME_RECORDS = this.API_URL_SPRING_BASE + "/library/getAllDmeRecords";

public readonly GET_ALL_ROA = this.API_URL_SPRING_BASE + "/library/getAllROA";

public readonly GET_ALL_CODELIST = this.API_URL_SPRING_BASE + "/library/getAllCodeList";

public readonly DETECT_SIGNAL = this.API_URL_SPRING_BASE + '/signal-analysis/detect';

public readonly GetAllAnalyses = this.API_URL_SPRING_BASE + '/signal-analysis/getAll';

public readonly GetAnalysisResult = this.API_URL_SPRING_BASE + '/signal-analysis/result';

public readonly UPLOAD_ORACLE_DATA = this.API_URL_SPRING_BASE+ "/oracleToFtp/upload";

public readonly REFRESH_ORACLE_DATA = this.API_URL_SPRING_BASE + "/oracleToFtp/refresh";
 
public readonly REGENRATE_PSS_WORD_DOCUMENT = this.API_URL_SPRING_BASE + '/product-strategy/generate-wordtemplate/{strategyId}';

public readonly GET_REPORTS_BASED_ON_TEMPLATEID = this.API_URL_SPRING_BASE + '/product-strategy/review-activities-report';

public readonly DOWNLOAD_REPORTS_BASED_ON_TEMPLATEID = this.API_URL_SPRING_BASE + '/product-strategy/download-review-activities-report';
public readonly GET_LIFECYCLE_AND_STATES = this.API_URL_SPRING_BASE + '/lifecycle/workflow-details';

public readonly GET_IMDRF_HIERARCHY = this.API_URL_SPRING_BASE + '/Imdrf/hierarchy';

public readonly GET_ANNEX_RELEASE_METADATA = this.API_URL_SPRING_BASE + '/Imdrf/AnnexReleaseMetaData';

public readonly GET_SEARCH_TERM_CODE_FROM_ANNEX = this.API_URL_SPRING_BASE + '/Imdrf/search';

public readonly GET_TERM_DETAILS = this.API_URL_SPRING_BASE + '/Imdrf/details/{code}/{releaseYear}';


public readonly GET_PRODUCTS_ON_SEARCH = this.API_URL_SPRING_BASE + '/products/search';

public readonly GET_SIGNALS_ON_SEARCH = this.API_URL_SPRING_BASE + '/signals/search';

public readonly GET_REVIEW_ACTIVITY_ON_SEARCH = this.API_URL_SPRING_BASE +'/review-activities/search';

public readonly GET_ALERT_RULE_ON_SEARCH = this.API_URL_SPRING_BASE +'/alert-rules/search';

public readonly GET_REPORT_TEMPLATE_BASED_ON_TEMPLATE_ID = this.API_URL_SPRING_BASE + '/product-strategy/reportTemplateDetailsOnTemplateID';


public readonly GET_DATASET_DETAILS_ON_DATASET_ID = this.API_URL_SPRING_BASE + '/getReportCreationBasedOnReportCreationId';

public readonly GET_REPORT_DETAILS_BASED_ON_REPORT_NAME = this.API_URL_SPRING_BASE + '/getReportDetailsBasedOnReportName';


public readonly GET_DEFAULT_ACTIVITIES = this.API_URL_SPRING_BASE +'/reviewActivityConfig/defaults/{workSpaceId}';

public readonly GET_IMDRF_RELEASE_YEARS = this.API_URL_SPRING_BASE +'/Imdrf/release-years';

public readonly GET_IMDRF_ANNEXX_CODE_BASED_ON_RELEASE_YEAR = this.API_URL_SPRING_BASE +'/Imdrf/annex-codes';

public readonly GET_METADATA_FILES_FOR_IMDRF_FOR_GIVEN_RELEASE_YEAR = this.API_URL_SPRING_BASE +'/Imdrf/metadata-files';

public readonly DOWNLOAD_METADATA_FILES_FOR_IMDRF_FOR_GIVEN_RELEASE_YEAR = this.API_URL_SPRING_BASE +'/Imdrf/download-metadata';


// Jtest New 3 new screens apis for Crud operation

public readonly COMPUTERIZED_SYSTEM_LIBRARY = this.API_URL_SPRING_BASE + '/ComputerizedSystemLibrary';

public readonly GET_ALL_COMPUTERIZED_SYSTEM_LIBRARY =this.COMPUTERIZED_SYSTEM_LIBRARY + '/workspace';

public readonly GET_COMPUTERIZED_SYSTEM_LIBRARY_BY_ID =this.COMPUTERIZED_SYSTEM_LIBRARY;

public readonly CREATE_COMPUTERIZED_SYSTEM_LIBRARY =this.COMPUTERIZED_SYSTEM_LIBRARY;

public readonly UPDATE_COMPUTERIZED_SYSTEM_LIBRARY =this.COMPUTERIZED_SYSTEM_LIBRARY;

public readonly DELETE_COMPUTERIZED_SYSTEM_LIBRARY = this.COMPUTERIZED_SYSTEM_LIBRARY;

public readonly UPDATE_COMPUTERIZED_SYSTEM_LIBRARY_STATUS =this.COMPUTERIZED_SYSTEM_LIBRARY;

  public readonly RELEASE_LIBRARY = this.API_URL_SPRING_BASE + '/releaselibrary';

  public readonly GET_ALL_RELEASE_LIBRARY = this.RELEASE_LIBRARY + '/workspace';
  public readonly GET_RELEASE_LIBRARY_BY_ID = this.RELEASE_LIBRARY;
  public readonly CREATE_RELEASE_LIBRARY = this.RELEASE_LIBRARY;
  public readonly UPDATE_RELEASE_LIBRARY = this.RELEASE_LIBRARY;
  public readonly DELETE_RELEASE_LIBRARY = this.RELEASE_LIBRARY;
  public readonly UPDATE_RELEASE_LIBRARY_STATUS = this.RELEASE_LIBRARY;

  
  public readonly REQUIREMENTS_LIBRARY = this.API_URL_SPRING_BASE + "/requirements-library";
  public readonly GET_REQUIREMENTS_LIBRARY = this.REQUIREMENTS_LIBRARY + "/workspace";
  public readonly CREATE_REQUIREMENTS_LIBRARY = this.REQUIREMENTS_LIBRARY;
  public readonly UPDATE_REQUIREMENTS_LIBRARY = this.REQUIREMENTS_LIBRARY;

  public readonly DELETE_REQUIREMENTS_LIBRARY =this.REQUIREMENTS_LIBRARY;

  public readonly UPDATE_REQUIREMENTS_LIBRARY_STATUS =this.REQUIREMENTS_LIBRARY;

  public readonly REQUIREMENTS_LIBRARY_INFO =this.REQUIREMENTS_LIBRARY + "/info";

  public readonly REQUIREMENTS_LIBRARY_RISK_RATING =  this.REQUIREMENTS_LIBRARY + "/risk-rating";

  public readonly REQUIREMENTS_LIBRARY_RELEASE_MODULE = this.REQUIREMENTS_LIBRARY + "/releaselibraryandmodule-info";

  public readonly RETRIEVE_ALL_USERS_BY_WORKSPACE = this.API_URL_SPRING_BASE + "/retrieveUsersByWorkspace";

  public readonly GET_DATA_EXTRACTOR_USERNAME_CONFIG = this.API_URL_SPRING_BASE + "/caseAuditExtraction/dataExtractor/username";
public readonly UPDATE_DATA_EXTRACTOR_USERNAME_CONFIG = this.API_URL_SPRING_BASE + "/caseAuditExtraction/usernameconfig";
public readonly DATA_EXTRACTOR_DASHBOARD_COUNTS = this.API_URL_SPRING_BASE + "/caseAuditExtraction/dashboardCounts";
public readonly GET_CURRENT_SOURCE_CSV =this.API_URL_SPRING_BASE + "/caseAuditExtraction/currentSourceCsvPath";
}
